module.exports = __webpack_public_path__ + "static/img/292_TO8_1958.6ddb566.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/292_TO8_1958.jpg
// module id = /ICG
// module chunks = 0